import './team-challenge.scss';
import Header from '../../components/header/header';
import TabsHome from '../../components/tabs-home/tabs-home';
import TeamChallengeService from '../../services/team-challenge-service';
import LocalStorage from '../../services/local-storage';
import { TEAM, SESSION } from '../../constants';
import { useState, useEffect, useRef, useCallback } from 'react';
import Button from '../../components/button/button';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import TranslateService from '../../services/translate-service';
import ModalTeamChallengeEnd from '../../components/modal-team-challenge-end/modal-team-challenge-end';

export default function TeamChallenge() {

    const navigate = useNavigate();

    const firstUpdate = useRef(true);
    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));
    const [status, setStatus] = useState(null);
    const [leaderboard, setLeaderboard] = useState([]);
    const [counterBack, setCounterBack] = useState('0 minutos 0 segundos');

    const updateCounterBack = useCallback(
        (statusChallenge) => {
            let now = moment();
            let dateRound = moment(statusChallenge.fechaSiguienteRonda);
            let diff = 0; 
    
            if(now.isBefore(dateRound)) {
                diff = dateRound.diff(now);
                if(diff < 1000 ) {
                    let statusCopy = {...status};
                    statusCopy.estatus = 'RESPONDER_RONDA';
    
                    setStatus(statusCopy);
                }
            } else {
                diff = now.diff(dateRound);
            }
    
            if(statusChallenge.estatus === 'RESPONDER_RONDA' || statusChallenge.estatus === 'PROXIMO_INICIAR') {
                setCounterBack(`${moment.utc(diff).format("m")} minutos ${moment.utc(diff).format("ss")} segundos `)
            }
            if(statusChallenge.estatus === 'ESPERAR_RONDA') {
                setCounterBack(moment.utc(diff).format("HH:mm:ss"))
            }
        },
        [status, setStatus, setCounterBack],
    );

    const getStatusChallenge = async () => {
        const response = await _getStatusChallenge();
        // console.log(response)
        setStatus(response);

        updateCounterBack(response);
    }
    
    const _getStatusChallenge = async () => {
        const response = await TeamChallengeService.getStatus(team.area._id, team._id, session._id);
        return response;
    }

    const getLeaderboard = async () => {
        const response = await TeamChallengeService.leaderboard(team.area._id, team._id, session._id);
        setLeaderboard(response);
    }

    const handleNextRound = async () => {
        const statusChallenge = await _getStatusChallenge();
        
        if(statusChallenge.estatus !== 'RESPONDER_RONDA') {
            return alert('Algo malo paso :(')
        }

        const response = await TeamChallengeService.nextRound(team.area._id, team._id, session._id);

        navigate('/team-challenge/question', { state: {questions: response} });
        
    }

    // const getPreviousLeaderboardRender = () => {
    //     if (status?.estatus !== "EXISTE_GANADOR") return null;

    //     const className = 'flex items-center py-5 pr-5 mb-2 ';
    //     return leaderboard.map((_item, index) => (
    //         <div className={className + (_item.equipo._id === team._id ? 'current' : '')} key={_item.equipo._id}>
    //             <div className='text-[50px] p-5'>
    //                 {index === 0 && '🥇'}
    //                 {index === 1 && '🥈'}
    //                 {index === 2 && '🥉'}
    //             </div>
    //             <div className='grow'>
    //                 <p>Team</p>
    //                 <p className='heading-h6 uppercase'>{_item.equipo.nombre}</p>
    //                 <p className='heading-h6 !text-secundary'>{_item.estadisticas}%</p>
    //                 <div className='progress mt-2'>
    //                     <div className='progress-bar' style={{ width: `${_item.estadisticas}%` }}></div>
    //                 </div>
    //             </div>

    //         </div>
    //     ))
    // }

    const getCurrentLeaderboardRender = () => {
        // if (status?.estatus === "EXISTE_GANADOR") return null;

        return (
            <table className='table-leaderboard'>
                <thead>
                    <tr>
                        <th className='text-center text-secundary font-bold text-[12px] w-[10%] uppercase'>{TranslateService.get('teamChallenge.leaderboard.ranking')}</th>
                        <th className='text-center text-secundary font-bold text-[12px] w-[25%] uppercase'>{TranslateService.get('teamChallenge.leaderboard.team')}</th>
                        <th className='text-center text-secundary font-bold text-[12px] w-[75%] uppercase'>{TranslateService.get('teamChallenge.leaderboard.progress')}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        leaderboard.map((_item, index) => (
                            <tr className={(_item.equipo._id === team._id ? 'current': '')} key={_item.equipo._id}>
                                <td className='heading-h6 text-center'>{index+1}</td>
                                <td className='heading-h6'>
                                    <p>{_item.equipo.nombre} <label className='medal'>🎖</label></p>
                                    <p className='text-heading-card my-team uppercase'>{TranslateService.get('teamChallenge.leaderboard.yourTeam')}</p>
                                </td>
                                <td className=''>
                                    <div className='progress'>
                                        <div className='progress-bar' style={{ width: `${_item.estadisticas}%` }}></div>
                                        <div className='text-right heading-h6 !text-default' style={{ width: `${_item.estadisticas}%` }}>{_item.estadisticas}%</div>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )
    }

    const formatTeamName = () => {
        let text = TranslateService.get('teamChallenge.subtitle.waiting');

        text = text.replace('{team}', team.nombre);
        
        return text;
    }
    
    const formatChallengeWillEnd = () => {
        let text = TranslateService.get('teamChallenge.subtitle.ongoing');

        text = text.replace('{date}', moment(status.reto.configuracion.fechaFin).format('DD/MM/YYYY HH:mm'));
        
        return text;
    }

    useEffect(() => {
        const interval = setInterval(() => {

            if(status.estatus === 'RESPONDER_RONDA' || status.estatus === 'ESPERAR_RONDA' || status.estatus === 'PROXIMO_INICIAR') {
                updateCounterBack(status);
            } else {
                clearInterval(interval)
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [status, updateCounterBack]);

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            getStatusChallenge();
            getLeaderboard();

            return;
        }
    });

    return (
        <>

            {/* <ModalTeamChallengeEnd isOpen={true} result={status} leaderboard={leaderboard} /> */}

            <div className='team-challenge'>
                <div className="bg-team-challenge">
                    <Header />

                    <div className=' bg-team-challenge-waves pt-7 pb-16'>
                        <div className='container  mx-auto px-4'>
                            <TabsHome />

                            <div className='mt-12'>
                                {
                                    (!status || status?.estatus === "EXISTE_GANADOR") && 
                                    <>
                                        <p className='font-family-montserrat uppercase  text-white text-center' dangerouslySetInnerHTML={{ __html: formatTeamName() }}></p>
                                        <h1 className='heading-h1 !text-white mt-2 text-center'>{TranslateService.get('teamChallenge.title.waiting')}</h1>
                                    </>
                                }
                                {
                                    status && (status.estatus === 'ESPERAR_RONDA' || status.estatus === 'PROXIMO_INICIAR') && 
                                    <>
                                        <h1 className='heading-h1 !text-white text-center'>{status.reto.configuracion.nombre}</h1>
                                        <p className='font-family-montserrat uppercase  text-white text-center mt-2 ' dangerouslySetInnerHTML={{ __html: formatChallengeWillEnd() }}></p>
                                    </>
                                }
                                

                                <div className='grid gap-[16px] grid-cols-12'>
                                    <div className='col-span-4 col-start-5'>
                                        {(!status || status?.estatus === "EXISTE_GANADOR") &&
                                            <div className='card text-center mt-9'>
                                                <p className='text-3xl'>⌛️</p>
                                                <p className='heading-h6 uppercase my-3'>{TranslateService.get('teamChallenge.description.title.waiting')}</p>
                                                <p>{TranslateService.get('teamChallenge.description.description.waiting')}</p>
                                            </div>
                                        }
                                        {(status?.estatus === "PROXIMO_INICIAR") &&
                                            <div className='card text-center mt-9'>
                                                <p className='text-3xl'>🤩</p>
                                                <p className='heading-h6 uppercase my-3'>{status.reto.configuracion.nombre}</p>
                                                <p>Llegó la hora de demostrar de qué están hechos los integrantes de {team.nombre} </p>
                                                <p className='mt-3'>La competencia comenzará en {counterBack}</p>
                                            </div>
                                        }
                                        {(status?.estatus === "RESPONDER_RONDA") &&
                                            <div className='card text-center mt-9'>
                                                <p className='text-3xl'>😎</p>
                                                <p className='heading-h6 uppercase my-3'>{session.nombre}, <label className='text-link-inactive'>It’s your turn!</label></p>
                                                <p>Hace ya {counterBack} que podías responder tu ronda de preguntas</p>
                                                
                                                <Button className='mt-4' onClick={handleNextRound}>
                                                    answer questions
                                                </Button>
                                            </div>
                                        }
                                        {(status?.estatus === "ESPERAR_RONDA") &&
                                            <div className='card text-center mt-9'>
                                                <p className='text-3xl'>⏰</p>
                                                <p className='heading-h6 uppercase my-3'>come back in</p>
                                                <p className='heading-h5 !text-default uppercase my-5'>{counterBack} hrs</p>
                                                <p>Wait for your turn to bring your team to victory.</p>
                                                
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className='grid gap-[16px] grid-cols-12 mt-[-32px] mb-8'>
                    <div className='col-span-8 col-start-3'>
                        <div className='card !p-[0px]'>
                            <div className='heading-h6 uppercase p-5'>
                                🏆
                                {(!status || status?.estatus === "EXISTE_GANADOR") && ' ' + TranslateService.get('teamChallenge.leaderboard.waiting.title')}
                                {(!status || status?.estatus !== "EXISTE_GANADOR") && ' ' + TranslateService.get('teamChallenge.leaderboard.ongoing.title')}
                            </div>
                            <div className=''>
                                {getCurrentLeaderboardRender()}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
